import { SchedulingFormValues } from './types';

export const SCHEDULING_TIMEFRAMES: { label: string; value: SchedulingFormValues['timeframe'] }[] = [
  { label: 'campaigns.form.scheduling.timeframes.open', value: 'open-hours' },
  { label: 'campaigns.form.scheduling.timeframes.specific', value: 'specific-times' },
];
